import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPills12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPills12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.429 6H1v1h1.429zM1 5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1.429a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm5.714 1H5.286v1h1.428zM5.286 5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1.428a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM9.57 6H11v1H9.571zm-1 0a1 1 0 0 1 1-1H11a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9.571a1 1 0 0 1-1-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPills12);
